import { Injectable } from "@angular/core";
import { IAddEditClient } from "src/app/Models/Interface/Client/add-edit-client";
import { DataService } from "../DataService/data.service";
import { Observable } from "rxjs";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { IPagination } from "src/app/Models/Interface/Pagination/pagination";
import { HttpParams } from "@angular/common/http";
import { IClient } from "src/app/Models/Interface/Client/client";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";
import { IActivateClient } from "src/app/Models/Interface/Client/activate-client";
import { MenuItem } from "primeng/api";

@Injectable({
  providedIn: "root",
})
export class ClientService {
  clientOBJ = {} as IAddEditClient;
  pagination = {
    skip: 0,
    take: 15,
    pagesCount: 0,
    inPageNumber: 1,
    leftItems: 0,
  } as IPagination;
  search: string = "";
  filter: string = "";
  activate = {} as IActivateClient;
  clientDetail = {} as IClient;
  items: MenuItem[] = [];
  constructor(private dataService: DataService) {}

  onAddClient(): Observable<boolean> {
    let formData = new FormData();
    formData.append("AccountTypeCode", this.clientOBJ.AccountTypeCode);
    if (this.clientOBJ.LogoImage) {
      formData.append(
        "LogoImage",
        this.clientOBJ.LogoImage,
        this.clientOBJ.LogoImage.name
      );
    }
    formData.append("Name", this.clientOBJ.Name);
    formData.append("PhoneNumber", this.clientOBJ.PhoneNumber);
    formData.append("Email", this.clientOBJ.Email);
    formData.append("Address", this.clientOBJ.Address);
    formData.append("CountryId", String(this.clientOBJ.CountryId));
    formData.append(
      "ContactPersonName",
      String(this.clientOBJ.ContactPersonName)
    );
    formData.append("IsShipOwner", String(this.clientOBJ.IsShipOwner));
    formData.append("IsShipOperator", String(this.clientOBJ.IsShipOperator));
    formData.append("IsShipAgent", String(this.clientOBJ.IsShipAgent));
    return this.dataService.post(APIName.client.addClient, formData);
  }

  getAllClients(): Observable<IBaseDataList<IClient[]>> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("skip", this.pagination.skip);
    params = params.append("take", this.pagination.take);
    params = params.append("keyword", this.search);
    params = params.append("statusCode", this.filter);
    return this.dataService.getWithParams(APIName.client.getAllClients, params);
  }

  getClientById(id: number): Observable<IClient> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("accountId", id);
    return this.dataService.getWithParams(APIName.client.getClient, params);
  }

  onUpdateClient(id: number): Observable<boolean> {
    let formData = new FormData();
    formData.append("Id", String(id));
    formData.append("Name", this.clientOBJ.Name);
    formData.append("AccountTypeId", String(this.clientOBJ.AccountTypeId));
    formData.append("IsShipOwner", String(this.clientOBJ.IsShipOwner));
    formData.append("IsShipOperator", String(this.clientOBJ.IsShipOperator));
    formData.append("IsShipAgent", String(this.clientOBJ.IsShipAgent));
    formData.append("CountryId", String(this.clientOBJ.CountryId));
    formData.append("AccountStatusId", String(this.clientOBJ.AccountStatusId));
    if (this.clientOBJ.LogoImage) {
      formData.append(
        "LogoImage",
        this.clientOBJ.LogoImage,
        this.clientOBJ.LogoImage.name
      );
    }
    formData.append("ContactPersonName", this.clientOBJ.ContactPersonName);
    formData.append("PhoneNumber", this.clientOBJ.PhoneNumber);
    formData.append("Email", this.clientOBJ.Email);
    formData.append("Address", this.clientOBJ.Address);
    return this.dataService.post(APIName.client.updateClient, formData);
  }

  onActivate(): Observable<boolean> {
    return this.dataService.post(APIName.client.activate, this.activate);
  }

  getClientDetails(id: number): any {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("accountId", id);
    // this.dataService.getWithParams(APIName.client.getClient, params).subscribe(res => {
    //     this.clientDetail = res
    //     console.log(this.clientDetail)
    // }, error => {
    // }, () => {
    //     // this.items = [
    //     //     {label: 'All Clients', routerLink: '/client'},
    //     //     {label: this.clientDetail.name},
    //     // ];
    // })
    this.dataService
      .getWithParams(APIName.client.getClient, params)
      .subscribe((res: IClient) => {
        this.clientDetail = res;
        this.items = [
          { label: "All Clients", routerLink: "/client" },
          { label: this.clientDetail.name },
        ];
      });
  }
}
